/**
 * Propriedades que o docx-report-generator permite para ChartOptionSerie, se o modelo for
 * incrementado com frequência, avaliar exportação dessas propriedades diretamente para
 * o analyze
 */
const KNOWN_SERIE_PROPERTIES = [
  'avoidLabelOverlap',
  'data',
  'label',
  'labelLine',
  'lineStyle',
  'minShowLabelAngle',
  'name',
  'radius',
  'seriesLayoutBy',
  'smooth',
  'stack',
  'symbolSize',
  'type',
];

/**
 * Reduz cada série do echartOption às propriedades aceitas pelo relatório.
 */
export default function applySerieContract(echartOption) {
  if (!echartOption || !Array.isArray(echartOption.series)) {
    return echartOption;
  }

  const series = echartOption.series.map((serie) => {
    if (!serie || typeof serie !== 'object') {
      return serie;
    }

    return KNOWN_SERIE_PROPERTIES.reduce((contractedSerie, property) => {
      if (property in serie) {
        contractedSerie[property] = serie[property];
      }

      return contractedSerie;
    }, {});
  });

  return { ...echartOption, series };
}

export { KNOWN_SERIE_PROPERTIES };
